export const tokens = {
    size: {
        min: 8,
        preference: 12,
        max: 64,
    },
    charWidth: {
        min: 3,
        preference: 4,
        max: 22,
    },
};
